exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\n    height: 300px;\n  }\n  textarea.fieldWithErrors,input.fieldWithErrors, .x-window input.x-form-invalid {\n    border-color: #f00!important;\n}\nspan.str {\n  color: #f00!important;\n}\n.right-sub-btn {\n  position:relative;\n}\np.error-msg {\n  position: absolute;\n  top: 45px;\n  right: 0;\n  padding: 10px;\n  border: 1px solid #ddd;\n  background: #fdcbcb;\n  border-radius: 20px;\n  margin: 0;\n  font-size: 10px;\n  color: #f00;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/info/info.css
// module id = ../../../../../src/app/event/info/info.css
// module chunks = main